import Vue from 'vue';
import Router from 'vue-router';
import api from '@/api';
import store from '@/store';
import Layout from './layout';
import Auth from './auth';
import Erro from './error';


Vue.use(Router);

let allRoutes = [];

allRoutes = allRoutes.concat(Auth, Erro, Layout);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: allRoutes,
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(m => m.meta.guarded === true)) {
    if (!store.getters.isLoggedIn) { return next('/login'); }
    if (!to.meta.allowed && !store.getters.userIsAllowed(to.meta.tagTela, to.meta.tagTelaFuncao)) { return next('*'); }
  }
  if (to.matched.some(m => m.meta.hasProgress)) {
    router.app.$Progress.start();
  }
  return next();
});

export default router;
